<script setup lang="ts">
definePageMeta({
  name: 'journal-article',
  key: (route) => {
    const p = route.params as { publisherId?: string, issueNumber?: string, articleNumber?: string }
    return `journal-article-${p.publisherId}-${p.issueNumber}-${p.articleNumber}`
  },
  layout: 'default-with-mobile-notice',
  theme: 'carbon',
  mobileReady: true,
})

const route = useRoute<'journal-article'>()

const publisherId = computed(() => route.params.publisherId ?? '')
const issueNumber = computed(() => route.params.issueNumber ?? '')
const articleNumber = computed(() => route.params.articleNumber ?? '')
</script>

<template>
  <JournalsArticlePage
    variant="issue"
    :publisher-id="publisherId"
    :issue-number="issueNumber"
    :article-number="articleNumber"
  />
</template>
